/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Channel_FarfetchInputs */

const en_price_channel_farfetch = /** @type {(inputs: Price_Channel_FarfetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farfetch`)
};

/**
* | output |
* | --- |
* | "Farfetch" |
*
* @param {Price_Channel_FarfetchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_channel_farfetch = /** @type {((inputs?: Price_Channel_FarfetchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Channel_FarfetchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_channel_farfetch(inputs)
});